module.exports = __webpack_public_path__ + "img/message.c3a24b87.svg";